import { t } from '@i18n';
import { formatDate, parseAmount } from '@utils';
import { PendingDispersion } from '../data/useGetPendingDispersions';

type DetailItem = {
  label: string;
  getText: (dispersion: PendingDispersion) => string | null | undefined;
};

/**
 * Fields from GET /v3/dispersion/pending/:id for the detail screen
 */
export const DETAIL_ITEMS: DetailItem[] = [
  {
    label: 'PENDING_DISPERSIONS:DETAIL:ID',
    getText: (dispersion) => dispersion.id,
  },
  {
    label: 'PENDING_DISPERSIONS:DETAIL:DISPERSION_ID',
    getText: (dispersion) => dispersion.dispersionId,
  },
  {
    label: 'PENDING_DISPERSIONS:DETAIL:CUSTOMER_NAME',
    getText: (dispersion) => dispersion.companyName || dispersion.customerName,
  },
  {
    label: 'PENDING_DISPERSIONS:DETAIL:CUSTOMER_ID',
    getText: (dispersion) =>
      dispersion.customerId !== null && dispersion.customerId !== undefined
        ? String(dispersion.customerId)
        : null,
  },
  {
    label: 'PENDING_DISPERSIONS:DETAIL:AREA',
    getText: (dispersion) => dispersion.areaName,
  },
  {
    label: 'PENDING_DISPERSIONS:DETAIL:AREA_ID',
    getText: (dispersion) =>
      dispersion.areaId !== null && dispersion.areaId !== undefined
        ? String(dispersion.areaId)
        : null,
  },
  {
    label: 'PENDING_DISPERSIONS:DETAIL:USERS_COUNT',
    getText: (dispersion) =>
      dispersion.usersCount !== null && dispersion.usersCount !== undefined
        ? String(dispersion.usersCount)
        : null,
  },
  {
    label: 'PENDING_DISPERSIONS:DETAIL:ATTEMPTED_AMOUNT',
    getText: (dispersion) =>
      dispersion.attemptedAmount !== null && dispersion.attemptedAmount !== undefined
        ? parseAmount(dispersion.attemptedAmount)
        : null,
  },
  {
    label: 'PENDING_DISPERSIONS:DETAIL:FILE_NAME',
    getText: (dispersion) => dispersion.fileName,
  },
  {
    label: 'PENDING_DISPERSIONS:DETAIL:FILE_PATH',
    getText: (dispersion) => dispersion.filePath,
  },
  {
    label: 'PENDING_DISPERSIONS:DETAIL:SCHEDULED_DATE',
    getText: (dispersion) =>
      dispersion.scheduledDate ? formatDate(dispersion.scheduledDate) : null,
  },
  {
    label: 'PENDING_DISPERSIONS:DETAIL:STATUS',
    getText: (dispersion) =>
      dispersion.status ? t(`PENDING_DISPERSIONS:STATUS:${dispersion.status}`) : null,
  },
  {
    label: 'PENDING_DISPERSIONS:DETAIL:CREATED_BY',
    getText: (dispersion) => dispersion.createdBy,
  },
  {
    label: 'PENDING_DISPERSIONS:DETAIL:CREATED_AT',
    getText: (dispersion) => (dispersion.createdAt ? formatDate(dispersion.createdAt) : null),
  },
  {
    label: 'PENDING_DISPERSIONS:DETAIL:UPDATED_AT',
    getText: (dispersion) => (dispersion.updatedAt ? formatDate(dispersion.updatedAt) : null),
  },
  {
    label: 'PENDING_DISPERSIONS:DETAIL:RESOLVED_BY',
    getText: (dispersion) => dispersion.resolvedBy,
  },
  {
    label: 'PENDING_DISPERSIONS:DETAIL:RESOLVED_AT',
    getText: (dispersion) => (dispersion.resolvedAt ? formatDate(dispersion.resolvedAt) : null),
  },
];
